'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cascader = require('./Cascader');

var _Cascader2 = _interopRequireDefault(_Cascader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _Cascader2['default']; // export this package's api

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-cascader/lib/index.js
// module id = 1082
// module chunks = 0